import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'

import {
  CREATE_QUESTION_BANK,
  IMPORTQUESTIONBANK,
  IMPORT_QUIZ,
  CREATE_SMART_QUIZ,
} from '@/config'
import { checkIntegration } from '@/routes/Integration/integrationHelpers'
import PermissionWrapper from '@/components/UI/PermissionWrapper/PermissionWrapper'
import CustomMenu from '@/components/UI/CustomMenu'
import CreateQuestionFromQuestionBank from './CreateQuestionFromQuestionBank'

function CreateQuestionsOptions(props: any) {
  const history = useHistory()
  const [createFromQuestionBankModal, setCreateFromQuestionBankModal] =
    useState(false)
  const [isCanvasIntegrated, setIsCanvasIntegrated] = useState({
    intregate: false,
    data: null,
    show: false,
  })

  useEffect(() => {
    checkIntegration({ setIsCanvasIntegrated, isCanvasIntegrated })
  }, [])

  const createQuestionFromQuestionBankHandler = () => {
    setCreateFromQuestionBankModal(!createFromQuestionBankModal)
  }

  const addMoreQuestionToQuiz = (question_ids: any[], quizId: any) => {
    props.addMoreQuestionToQuiz(question_ids, quizId)
    createQuestionFromQuestionBankHandler()
  }

  return (
    <>
      <CreateQuestionFromQuestionBank
        show={createFromQuestionBankModal}
        selectedGroupIdForDocument={props.knowledge_group_ids}
        isEditQuiz={true}
        quizId={props.quizId}
        onHide={createQuestionFromQuestionBankHandler}
        confirmHandler={() => {}}
        // toolkitSmartQuizAddMoreQue={props.toolkitSmartQuiz}
        queTypes={props.queTypes}
        addMoreQuestionToQuiz={addMoreQuestionToQuiz}
      />

      <PermissionWrapper>
        <CustomMenu
          textTrigger={`+ ${props.questionBank ? t('Add') : t('Add Question')}`}
          slotProps={{ trigger: { sx: { ml: 'auto' } } }}
          options={[
            {
              label: t('Import from Question bank'),
              hide: props.questionBank,
              onClick: createQuestionFromQuestionBankHandler,
            },
            {
              label: t('Generate from Document'),
              onClick: () => {
                history.push({
                  pathname: CREATE_SMART_QUIZ,
                  state: {
                    groupId: props.knowledge_group_ids,
                    questionType: props.queTypes,
                    quizId: props?.quizId,
                  },
                  search: props?.quizId
                    ? `?quizId=${props.quizId}&source=existing`
                    : `?source=existing`,
                })
              },
            },
            {
              label: t('Upload a test'),
              onClick: () => {
                const basePath = props?.quizId
                  ? IMPORT_QUIZ
                  : IMPORTQUESTIONBANK
                history.push(
                  basePath +
                    '?group=' +
                    props.knowledge_group_ids +
                    '&quizId=' +
                    props?.quizId,
                  {
                    quizId: props?.quizId, //call from create/edit quiz
                  },
                )
              },
            },
            {
              label: t('Create from scratch'),
              onClick: props.addNewQuestion
                ? props.addNewQuestion
                : () => {
                    history.push(
                      CREATE_QUESTION_BANK +
                        '?group=' +
                        props.knowledge_group_ids,
                    )
                  },
            },
          ]}
        />
      </PermissionWrapper>
    </>
  )
}

export default CreateQuestionsOptions
